export default "__VITE_ASSET__CnLgffCs__"